import { TextField } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime";
import TagBox from "components/TagBox";
import { jobOrderColNm } from "constants/jobOrderConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useCallback, useContext, useMemo } from "react";

const shortDateProp = {
  inputFormat: "DD/MM HH:mm",
  mask: "__/__ __:__"
}

const JODataExtraComponent = ({joData, setJOData, tagData, setTagData}) => {


  const datePickerJobOrderProp = useCallback((name, isRequire) => ({
    label: jobOrderColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: joData[name],
    onChange: (newValue) => { setJOData(oldState => ({ ...oldState, [name]: newValue && newValue.format("YYYY-MM-DD HH:mm:00.00") })) },
    renderInput: (params) => <TextField size="small"  {...params} required={isRequire} sx={{ width: 150 }} />,
  }), [joData, setJOData])

  const { msData } = useContext(GlobalStateContext)

  const refJobOrderColNm = useMemo(() => {
    const result = { ...jobOrderColNm }
    const refColumnName = msData.serverData.RefColumnName?.job_order || {}
    for (const name in refColumnName) {
      result[name] = refColumnName[name]
    }
    return result
  }, [msData.serverData])



  const dataProp = useCallback((name) => ({
    variant: "outlined",
    size: "small",
    name: name,
    label: refJobOrderColNm[name],
    value: joData[name],
    onChange: (e) => setJOData((oldData) => ({ ...oldData, [name]: e.target.value }))
  }), [joData, setJOData, refJobOrderColNm])
  return (
    <BoxFR sx={{alignItems: "stretch"}}>
      <BoxFC sx={{ gap: 1, mt: 3 }}>

        <DateTimePickerCustomTime {...datePickerJobOrderProp("FinDte", false)} {...shortDateProp} />

        <TagBox value={tagData} setValue={setTagData} tblAbbr="JO" sx={{ width: 150 }} />
      </BoxFC>
      <BoxFC sx={{ gap: 1, mt: 3 }}>

        <DateTimePickerCustomTime {...datePickerJobOrderProp("TakeAptTm", false)} {...shortDateProp} />
        <DateTimePickerCustomTime {...datePickerJobOrderProp("RtnAptTm", false)} {...shortDateProp} />
        <TextField {...dataProp("Ref1")} sx={{ width: 150 }} />
        <TextField {...dataProp("Ref2")} sx={{ width: 150 }} />
      </BoxFC>
    </BoxFR>
  )
}

export default React.memo(JODataExtraComponent);